<template>
  <div>
    <modal 
      class="dialer_animation right_side_popup m-w-600 scrollable bigSquareCheckbox IosModal" 
      width="50%" 
      :scrollable="true" 
      height="auto"  
      :name="modalName" 
      @before-open="onBeforeOpen($event)" 
      @before-close="onBeforeClose()"
    >
      <Voicemail :accountcode="data.accountcode" @back="$modal.hide(modalName)" />
    </modal>
  </div>
</template>

<script>
import Voicemail from '../settings/Voicemail.vue'
export default {
  name: "VoicemailSettingModal",
  components: {
    Voicemail,
  },
  props: {
    modalName: {
      type: String,
      default: 'VoicemailSetting'
    },
  },
  data() {
    return {
      data: {
        accountcode: '',
      },
    };
  },
  methods: {
    onBeforeOpen(event){
      this.data.accountcode=event?.params?.account ?? ''
    },
    onBeforeClose(){
      this.data.accountcode=''
    },
  },
};
</script>

<style lang="scss" scoped>

</style>